import { T } from "@bbnpm/bb-ui-framework";
import "./loading.min.css";

const Loading = () => {
    return (
        <div className="loading">
            <div>
                <div className="top">
                    <div className="leftBox">
                        <T.H3>Loading Bloomberg Terminal...</T.H3>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Loading;
